import { Box } from '@mui/material'
import { useEffect, useState } from 'react'
import { useMutation, useQueryClient } from 'react-query'
import { useDispatch } from 'react-redux'
import WalletLoanCard from '../../components/card/walletCard/walletLoanCard'
import { WALLET_KEY } from '../../config/cacheKey'
import { IGetCategoriesResponse, IMainGetCategoriesResponse } from '../../models/store.model'
import { IGetCustomerWalletsInfoResponse } from '../../models/wallet.model'
import { changeRouteType, getpervInnerState } from '../../redux/handleBackBtn/handleBackBtnSlice'
import { setHeaderTitle, setPageData } from '../../redux/headerTitle/headerTitleSlice'
import { GetAllCategories, GetCategories } from '../../services/store.service'
import { IStoreContainerOriginal } from '../navigationButtonComponents/walletContainer/IStoreContainer'
import StoreTabSkeleton from './storeTabSkeleton'
import StoresCategory from './storesCategory'

const StoreTab = ({ setTabChild, setState }: IStoreContainerOriginal) => {

    const [subCategories, setSubCategories] = useState<IMainGetCategoriesResponse[]>([])
    const dispatch = useDispatch();
    const queryClient = useQueryClient();
    const walletKey: string = queryClient.getQueryData(WALLET_KEY)!;
    const wallets: IGetCustomerWalletsInfoResponse[] = queryClient.getQueryData('wallets')!
    const randomKeyForDispatch = Math.random();
    const selectedWallet = wallets?.filter((wallet) => wallet?.key === walletKey)
    const { mutate: GetAllCategoriesMutate, isLoading } = useMutation(GetAllCategories, {
        onSuccess: (data: IGetCategoriesResponse[]) => {
            if (data) {


                setSubCategories(data);
            }
        },
        onError: () => { },
    });

    useEffect(() => {

        if (walletKey) {

            GetAllCategoriesMutate({ walletKey: walletKey })
        }
        else {
            GetAllCategoriesMutate({})

        }
        dispatch(changeRouteType({ routeType: 'child' }));
        dispatch(getpervInnerState({ prevInnerState: `wallet ${randomKeyForDispatch}` }));

    }, [])
    useEffect(() => {
        if (walletKey) {

            dispatch(setHeaderTitle({ header: 'دسته بندی محصولات', color: 'var(--input-bg-color)', parentRoute: 'store' }));

        }
        else {

            dispatch(setHeaderTitle({ parentRoute: null, display: "none" }))
        }


    }, [walletKey])

    const subCategoryHandleOnClick = (id: number) => {

        dispatch(setPageData({ page: 'storeTab', id }));
        setState!('sellers')

    }

    if (isLoading) return <StoreTabSkeleton />


    return (
        <div
            className={walletKey ? `overflow-y-auto h-[calc(100svh-120px)]` : `overflow-y-auto h-[calc(100svh-120px)] sm:h-[calc(100svh-82px)] pt-3 pb-2`}
        >
            {walletKey && <Box sx={{ boxShadow: "0px 0px 4px rgba(0,0,0,0.3)", background: "var(--input-bg-color)", height: "25%", display: "flex", alignItems: "center", width: "100%", paddingX: "40px" }}>
                <WalletLoanCard amount={selectedWallet[0]?.balance} date={selectedWallet[0]?.expirationDatePersian} title={selectedWallet[0]?.title} color={selectedWallet[0]?.colorHexCode} />
            </Box>}
            <Box sx={{ paddingInline: "10px", height: "100%", paddingTop: "10px" }}>

                <StoresCategory subCategories={subCategories}
                    onClick={subCategoryHandleOnClick}
                />

            </Box>
        </div>
    )
}

export default StoreTab